import type { RouteRecordRaw } from 'vue-router'

export const PATIENTS = 'patients'
export const PATIENT_DETAILS = 'patient-details'
export default [
  {
    path: '/patients',
    name: PATIENTS,
    component: () => import('./views/PatientSearch.vue'),
    meta: {
      auth: true,
    },
    children: [
      {
        path: ':patientId',
        name: PATIENT_DETAILS,
        component: () => import('./views/PatientSearch.vue'),
        meta: {
          auth: true,
        },
      },
    ],
  },
] as RouteRecordRaw[]
